export enum LinkType {
  CREATE_NEXT_NOTICE = 'SELFSERVICE_CREATE_NEXT_NOTICE',
  NPS_QUESTIONNAIRE = 'SELFSERVICE_NPS_QUESTIONNAIRE',
  MY_PZU_REDIRECTION = 'SELFSERVICE_MY_PZU_REDIRECTION'
}

export interface LinkActivityLog {
  page: string | undefined;
  linkType: LinkType | undefined;
}
